/**
 * As três séries da curva Ampli chegam por dois caminhos: `getDetail` publica
 * `plannedCashFlowSeries.ampliDisbursement` / `.cashProjection` / `.remaining` na
 * seleção da obra e `getFollowUps` publica `ampliDisbursements` / `cashProjection` /
 * `remaining` a cada mudança de período. Ler só um dos dois deixa o gráfico vazio na
 * primeira pintura ou velho depois do filtro — a precedência mora aqui, testada uma vez.
 */

const asSeries = (value) => (Array.isArray(value) ? value : null);

/**
 * UM array vazio para todos os "sem série", congelado no módulo.
 *
 * Os três resolvedores alimentam dependências de `useMemo`/`useEffect` no
 * `FinancialBarChart` e no acordeão. Um `[]` novo a cada chamada é uma referência
 * nova a cada render, então TODO memo que dependesse dele recomputaria em todo
 * render de uma obra sem curva Ampli — que é justamente o caso mais comum. Congelado
 * porque uma referência compartilhada não pode ser mutada por engano por nenhum
 * consumidor.
 */
export const EMPTY_SERIES = Object.freeze([]);

export const resolveAmpliSeries = (project) => (
  asSeries(project?.ampliDisbursements)
  ?? asSeries(project?.plannedCashFlowSeries?.ampliDisbursement)
  ?? EMPTY_SERIES
);

export const resolveCashProjectionSeries = (project) => (
  asSeries(project?.cashProjection)
  ?? asSeries(project?.plannedCashFlowSeries?.cashProjection)
  ?? EMPTY_SERIES
);

export const resolveRemainingSeries = (project) => (
  asSeries(project?.remaining)
  ?? asSeries(project?.plannedCashFlowSeries?.remaining)
  ?? EMPTY_SERIES
);

export const monthlySeriesTotal = (series) => (
  (Array.isArray(series) ? series : []).reduce(
    (total, point) => total + (Number.isFinite(point?.value) ? point.value : 0),
    0,
  )
);

/**
 * Same total as `monthlySeriesTotal`, but `null` when there is no series to sum —
 * a missing or empty `monthlyProjection.ampliDisbursement`/`.cashProjection` means
 * "no data for this node", not "zero", so the accordion must render "—" instead of
 * a value that would read as a real R$ 0,00.
 */
export const monthlySeriesTotalOrNull = (series) => (
  Array.isArray(series) && series.length > 0 ? monthlySeriesTotal(series) : null
);
